<mat-drawer-container class="example-container">
  <mat-drawer position="end" #drawer mode="side">
   <!-- <div>
      <div class="text-center w-100 btn btn-primary p-4 m-0">
        Questions List
        <a class="float-end" (click)="drawer.close()">
          <svg class="bi" width="40" height="16">
            <use xlink:href="#close"></use>
          </svg>
        </a>
      </div>
    </div>-->

    <div class="list-group">
      <a
        *ngFor="let ques of questions; let i = index"
        class="list-group-item list-group-item-action"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ ques.speaker }}</h5>
          <small class="text-muted">{{
            ques.created_at | date: "shortTime"
          }}</small>
        </div>
        <p class="mb-1">{{ ques.question }}</p>
        <small class="text-muted">{{ ques.user }}</small>
      </a>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <!-- left side -->

   <!-- <app-side-bar></app-side-bar>-->

    <div class="container-fluid p-0 main-wrapper">
      <app-header></app-header>
<div class="row">
  <ng-template #waitConsent>
  <div class="text-center p-4">Please complete consent to start watching.</div>
</ng-template>
<!-- Page padding -->
 <div *ngIf="consentGiven; else waitConsent"></div>
    <!-- ===== Live Embed (centered, below) ===== -->
    <div class="row mt-5 mb-5 justify-content-center">
      <div class="col-12 col-xl-10">
        <div class="ratio ratio-16x9" >
          <iframe
            class="embed-responsive-item"
            [src]="'https://player.vimeo.com/video/1131582626' | safeUrl"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        
        </div>

        <!-- YouTube (optional) -->
        <div *ngIf="live_type == 'youtube' && youtube" class="ratio ratio-16x9 mt-3">
          <iframe
            class="embed-responsive-item"
            [src]="'https://www.youtube.com/embed/' + youtube + '?autoplay=1&rel=0' | safeUrl"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameborder="0"
            allow="autoplay"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <!-- ===== /Live Embed ===== -->
<div class="row justify-content-center" style="padding: 0 70px;">
  <div class="col-12 col-xxl-10">

    <!-- ===== Top row: Info (card) + Speaker (card) ===== -->
    <div class="row g-4 align-items-stretch justify-content-center text-center">

      <!-- Left: Title + Date/Time + Timer + CTA (as a card for symmetry) -->
      <div class="col-12 col-lg-7 d-flex">
        <div class="card w-100 h-100 border-0 shadow-sm">
          <div class="card-body px-4 px-md-5 py-4">
            <h2 class="pane-heading mb-2" style="letter-spacing:.3px;">EGPA LIVE CAST</h2>

            <div class="h5 fw-normal text-muted mb-3">
              Wednesday, Oct 29th, 2025<br/>
              8:30 pm, Bahrain/Kuwait/Qatar Time<br/>
              9:30 pm, UAE/Oman Time
            </div>

            <div class="mb-4">
              <app-timer></app-timer>
            </div>

           <!-- <div class="d-flex flex-wrap justify-content-center gap-3">
              <a class="btn btn-primary px-4" style="min-width: 200px;" (click)="openDialog('')">
                Submit a Question
              </a>

              <a *ngIf="is_admin"
                 class="btn btn-outline-primary px-4"
                 style="min-width: 200px;"
                 (click)="drawer.toggle()">
                Question List
              </a>
            </div>-->
          </div>
        </div>
      </div>

      <!-- Right: Speaker (narrower card, smaller image) -->
      <div class="col-12 col-lg-5 d-flex">
        <div class="card w-100 h-100 border-0 shadow-sm mx-auto" style="max-width: 420px;">
          <div class="card-header bg-transparent text-center">
            Speaker
          </div>

          <!-- Tamed image height for balance -->
          <img
            src="https://medicalevents.tv/cm_ups/attachments/2025/10/28/Vigx9IUVpNR4sTWipHGOmGjXvqohxvn8a5Hn2cHu.jpg"
            alt="Speaker photo"
            class="card-img-top"
            style="height: 260px; object-fit: contain; object-position: center;"
          />

          <div class="card-body py-3">
            <h5 class="card-title mb-2">Dr. Rachel Kaminski</h5>
            <p class="card-text mb-0 text-muted">
              Consultant Pulmonologist<br/>
              Saudi German Hospital<br/>
              Dubai, UAE
            </p>
          </div>
        </div>
      </div>

    </div>
    <!-- ===== /Top row ===== -->

 

  </div>
</div>



</div>



      <div class="container pt-5 table-responsive" >
      <h5 style="text-align: center; font-weight: 700;">Microsoft <span style="color: rgba(255, 0, 0, 0.589);">Privacy Policy.</span> GSK <span style="color: rgba(255, 0, 0, 0.589);">Privacy Policy.</span></h5>
      <p style="text-align: center;">This event is powered by Microsoft Teams, under the direction of the meeting organizer. The data processing that occurs for purposes
of this event is subject to the terms of the meeting organizer.</p>


        <table class="table">
          <tbody>
            <tr>
              <td>

      
    

    
    For more information, please refer to the prescribing information or contact GlaxoSmithKline via <a href="mailto:Gcc.Medinfo@gsk.com">Gcc.Medinfo@gsk.com</a>.
    
    To report Adverse Event/s associated with the use of GSK product/s, please get in touch with us via <a href="mailto:gulf.safety@gsk.com">gulf.safety@gsk.com</a>.
    
    To report quality complaint/s associated with the use of GSK product/s, please contact us via <a href="mailto:Gulf.ProductQualityComplaints@gsk.com">Gulf.ProductQualityComplaints@gsk.com</a>.<br><br>
    
   <!-- About this email: GSK Gulf has selected this email to be of interest to you in line with your email preferences, which you can edit or
<a href="https://url703.gulf.gsk.com/asm/unsubscribe/">unsubscribe</a> from at any time.You can also view our <a href="https://terms.gsk.com/en-sa/pharmaceuticals/default/">terms of use</a>.<br><br>
    
    
    About your privacy: GSK may monitor our technology tools and services (including email, phone, and other communications sent to and from GSK) in order to maintain the security of systems, and to protect our staff, customers, and business partners from cyber threats and loss of information. These monitoring activities include checks for offensive materials, viruses, and other malignant code, and unauthorized or unlawful activity. 
    
    GSK monitoring is conducted with appropriate confidentiality controls and in accordance with local laws. You can learn about the information that we may process about you, and how we use your information, <a href="https://assets.gskstatic.com/pharma/GSKpro/Gulf/hcp-global-notice-11-aug-20.pdf">here</a> <br>
  
    <br>
    
    Trademarks are owned by or licensed to the GSK group of companies.
    <br>
    ©2025 GSK group of companies or its licensor. All rights reserved.
    <br>
    The following contact information must be used by healthcare professionals from UAE in addition to the GSK safety reporting email:-->
              </td>
            </tr>
          </tbody>
        </table>
    <div class="row align-items-center">
      <p>The following contact information must be used by healthcare professionals from Oman in addition to the GSK safety reporting email</p>
      <div class="col">
    
        <table class="table " > 
        
          <tbody>
            <tr>
              <td>
                Department of Pharmacovigilance & Drug Information Drug <br>Safety Center
    <br>
    Ministry of Health, Sultanate of Oman
    <br>
    Phone Nos. 0096822357690 / 0096822357687

    <br>
    Fax: 0096822358489
    <br>
    Email: pharma-vigil@moh.gov.om 
    <br>
    Website: www.moh.gov.om
    <br> <br> 
    
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col">
        <table class="table " dir="rtl" > 
          <thead >
           
          </thead>
          <tbody>
            <tr>
              <td>
دائرة الیقظة والمعلومات الدوائیة
<br>
مركز سلامة الدواء 
<br>
    وزارة الصحة، سلطنة عمان
    <br>
    هاتف: 0096822357687 / &nbsp; 0096822357690 
    <br>
    فاكس: 0096822358489
    <br>
    البريد الالكتروني:  pharma-vigil@moh.gov.om
      <br>
    الموقع الالكتروني: www.moh.gov.om 
    <br>
    <br>
    
    
              </td>
            </tr>
          </tbody>
        </table>
      </div>
              <p>GSK may process personal information about you when you participate in GSK webcasts. For more information, please read our privacy statement.</p><br>

            <p><a href="https://terms.gsk.com/en-xg/pharmaceuticals/default/">Terms of use</a> &nbsp; &nbsp;&nbsp;<a href="https://privacy.gsk.com/en-xg/privacy-notice/">Privacy Statement</a></p>  

            <p>Copyrights statement: ©2025 GSK group of companies or its licensor. All rights reserved.</p><br>
            <p>Trademarks are owned by or licensed to the GSK group of companies.</p>
      
     
    </div>
        
      </div>
      <div class="row">
        <div class="col-12 p-0">
          <div class="footer">
            <img src="./assets/img/bottom.png" class="blob-bright img-fluid" />
          </div>
        </div>
      </div>
    </div>

    <!-- </div> -->
    <!-- end container -->
  </mat-drawer-content>
</mat-drawer-container>
